import React, { useEffect, useState } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";
import { API } from "api";
import AppContainer from "components/ui/AppContainer";
import AppSearchInput from "components/ui/AppSearchInput";
import AppButton from "components/ui/AppButton.jsx";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import AppIcon from "components/ui/AppIcon.jsx"
import AppSwitch from "components/ui/AppSwitch.jsx";

const Discount = () => {
  const zone = moment.tz.guess();
  moment.tz.setDefault(zone);
  const [loading, setLoading] = useState(false);
  const [discounts, setDiscounts] = useState([]);

  const history = useHistory();
  const { t } = useTranslation();
  const [searchTerm, setSearch] = useState("");
  const addDiscount = () => {
    history.push("/app/dashboard/adddiscount");
  };
  const fetchAllDiscounts = async () => {
    setLoading(true);
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_ALL_COUPONS({
      token: userDetail.token,
      brandId: userDetail.brandId,
    });
    if (result?.success == 1) {
      setDiscounts(result.discount);
    } else UTILS.errorNotification("Please try again later");
    setLoading(false);
  };

  useEffect(() => {
    fetchAllDiscounts();
  }, []);
  const formatTime = (time) => {
    return moment.unix(time).locale("en").tz(moment.tz.guess()).format();
  };
  const handlePlayPause = async ( val, row) => {
    setLoading(true);
    row["isActive"] = val;
    row["startDate"] = formatTime(row["startDate"]);
    row["endDate"] = formatTime(row["endDate"]);
    const userDetail = UTILS.getCurrentUser();
    const result = await API.UPDATE_COUPONS({
      token: userDetail.token,
      data: row,
    });
    if (result?.success == 1) {
      UTILS.successNotification(t("Discount Updated successfully"));
      fetchAllDiscounts();
    }
  };
  const renderPlayPauseComponent = (value, rowData, index) => {
    return (
      <div key={index}>
          
        <AppSwitch checked={rowData?.isActive} onChange={(v)=>handlePlayPause(v,rowData)}></AppSwitch>
      </div>
    );
  };
  const editCouponPage = (row) => {
    history.push({
      pathname: "/app/dashboard/updatediscount",
      state: {
        discount: row,
      },
    });
  };
  const reanderTtile = (value, row, index) => {
    return (
      <div>
        <strong className="">
          {row?.discountCode}
        </strong>
        <p className="m-0">{value}</p>
      </div>
    );
  };
  const editCoupon = (value, row, index) => {
    return (
      <div>
        <strong className="">
          <a
            to="#"
            className="inline-block px-2"
            onClick={() => editCouponPage(row)}
          >
            <AppIcon name="edit"/>
          </a>
        </strong>
      </div>
    );
  };
  const renderType = (value, row) => {
    return (
      <div className="text-center">
        <span>{t(value)}</span>
        {row.isApplicableOnAllItems ? (
          <p className="">{t("Applies to all items")}</p>
        ) : (
          <p className="">{t("Applies to selected items")}</p>
        )}
      </div>
    );
  };
  const reanderAvailablity = (value, row) => {
    return (
      <div>
        <span>{moment.unix(row.startDate).format("DD-MM-YYYY")}</span> -{" "}
        <span>{moment.unix(row.endDate).format("DD-MM-YYYY")}</span>
      </div>
    );
  };
  const deleteButton = () => {
    return (
      <div>
        <svg
          data-v-1826c20e=""
          viewBox="0 0 20 20"
          fill="currentColor"
          xmlns="https://www.w3.org/2000/svg"
          className="w-5 h-5 inline-block  mx-2 cursor-pointer hover:text-red-500"
        >
          <path
            fillRule="evenodd"
            d="M2.451 3.989A.75.75 0 013 3.75h14a.75.75 0 01.748.803l-.867 12.143a2.75 2.75 0 01-2.743 2.554H5.862a2.75 2.75 0 01-2.743-2.554L2.252 4.553a.75.75 0 01.2-.564zM3.805 5.25l.81 11.34a1.25 1.25 0 001.247 1.16h8.276c.656 0 1.2-.507 1.247-1.16l.81-11.34H3.805z"
            clipRule="evenodd"
          ></path>
          <path
            fillRule="evenodd"
            d="M1.25 4.5A.75.75 0 012 3.75h16a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75z"
            clipRule="evenodd"
          ></path>
          <path
            fillRule="evenodd"
            d="M6.947 1.804a1.893 1.893 0 011.338-.554h3.429a1.893 1.893 0 011.893 1.893v1.143a.75.75 0 01-.75.75H7.143a.75.75 0 01-.75-.75V3.143c0-.502.199-.984.554-1.339zm1.338.946a.393.393 0 00-.392.393v.393h4.214v-.393a.393.393 0 00-.393-.393H8.285zm.001 4.786a.75.75 0 01.75.75V14a.75.75 0 01-1.5 0V8.286a.75.75 0 01.75-.75zm3.428 0a.75.75 0 01.75.75V14a.75.75 0 01-1.5 0V8.286a.75.75 0 01.75-.75z"
            clipRule="evenodd"
          ></path>
        </svg>
      </div>
    );
  };
  const columns = [
    {
      title: "Enabled",
      dataIndex: "isActive",
      key:"isActive",
      align: "center",

      render: renderPlayPauseComponent,
    },
    
    {
      title: t("Discount"),
      dataIndex: "discountName",
      align: "center",
      key: "discountName",
      render: reanderTtile,
    },
    
    {
      title: t("Application"),
      dataIndex: "discountApplication",
      align: "center",
      key: "discountApplication",
      render: (value) => {
        return (
          <div className="flex items-center justify-center">{t(value)}</div>
        );
      },
    },
    {
      title: t("Type"),
      dataIndex: "discountType",
      key: "discountType",
      align: "center",
      render: renderType,
    },
    {
      title: t("Amount"),
      dataIndex: "discountAmount",
      key: "discountAmount",
      align: "center",
      render: (value) => {
        return <div className="flex items-center justify-center">{value}</div>;
      },
    },
    {
      title: t("Min. Basket"),
      dataIndex: "minOrderValue",
      key: "minOrderValue",
      align: "center",
      render: (value) => {
        return <div className="flex items-center justify-center">{value}</div>;
      },
    },
    {
      title: t("Max. Discount"),
      dataIndex: "maximumDiscountValue",
      key: "maximumDiscountValue",
      align: "center",
      render: (value) => {
        return <div className="flex items-center justify-center">{value}</div>;
      },
    },
    {
      title: t("Availability"),
      dataIndex: "startDate",
      key: "startDate",
      align: "center",
      render: reanderAvailablity,
    },

    {
      title: t("Allowed Usage"),
      dataIndex: "maxUsage",
      key: "maxUsage",
      align: "center",
      render: (value) => {
        return <div className="flex items-center justify-center">{value}</div>;
      },
    },
    
    {
      title: t("Action"),
      dataIndex: "action",
      key: "action",
      fixed: "right",
      align: "center",
      render: editCoupon,
    },
  ];
  const Items = React.useMemo(() => {
    if (searchTerm === "" || searchTerm === null) {
      return discounts;
    }

    let searchTermLower = searchTerm.toLowerCase().trim();
    let d = discounts.filter((item) => {
      return (
        item.discountName?.toLowerCase().includes(searchTermLower) ||
        item.discountCode?.toLowerCase().includes(searchTermLower)
      );
    });
    return d;
  }, [discounts, searchTerm]);

  const handSearch = (e) => {
    setSearch(e.target.value);
  };
  return (
    <AppContainer loading={loading} title={t('Discounts')} subTitle={t('Here you can track all your discounts details in one place.')} >
          <div className="flex justify-between flex-col sm:flex-row mb-5">
            <h2 className="text-20px font-semibold leading-tight text-gray-900">Discount List</h2>
            <div className="flex flex-col gap-3 sm:flex-row">
              <AppSearchInput 
                  placeholder={t("search discount by name")}
                  value={searchTerm}
                  autoComplete="off"
                  onInput={handSearch}/>
              <AppButton size="sm" onClick={addDiscount}>{t("Add discount")} </AppButton>
            </div>
          </div>
          <AppPaginatedTable columns={columns} data={Items}></AppPaginatedTable>

    </AppContainer>
  );
};

export default Discount;
